export default __webpack_public_path__ + "static/media/6.70c8e04f.PNG";